<template>
    <div class="quick-ticket-check">
        <v-row dense>
            <!-- ticket number 6 -->
            <v-col cols="10" sm="11" class="" align-self="center">
                <div class="body-2 mb-1">Ticket No.  (番号を入力し「OK」を押してください。Please enter the No. and click "OK" button)</div>
                <v-text-field
                    v-model="ticketNumber"
                    label="Type here"
                    single-line
                    solo
                ></v-text-field>
            </v-col>
            <v-col cols="2" sm="1" class="" align-self="center">
                <v-row justify="center">
                    <v-btn small color="info darken-1" depressed @click="getFDTicketInfo()">
                        OK
                    </v-btn>
                </v-row>
            </v-col>
            <v-col v-if="ticketInfo.data" cols="12">
                {{ticketInfo.data.subject}}
                <br/><br/>
                {{ticketInfo.data.description_text}}
            </v-col>
            <v-col cols="12" v-if="ticketInfo.assignedTo">
                <span class="font-weight-bold red--text">{{ticketInfo.assignedTo}}</span>
            </v-col>
        </v-row>
    </div>
</template>

<script>
/* eslint-disable no-console */
import freshConfig from '@/freshconfig'
import axios from 'axios'
import {db} from '@/fb'

export default {
    name:'quickTicketCheck',
    data () {
        return {
            ticketNumber:null,
            ticketInfo:{
                data:null,
                assigned:null,
                assignedTo:null,
                taken:null,
            },
        }
    },
    methods:{
        async getFDTicketInfo(){
            const API_KEY = freshConfig.api_key;
            const URL = freshConfig.endpoint + 'tickets/' + String(this.ticketNumber);
            try{
                let ref = db.collection('ticket_assigned').where('ticket_number','==',parseInt(this.ticketNumber))
                ref.get().then(snap=>{
                    if(!snap.empty){
                        this.ticketInfo.assigned = true
                        snap.forEach(doc=>{
                            this.ticketInfo.assignedTo = `Ticket has been assigned to ${doc.data().researchers}`
                            if(doc.data().researcher_replied){
                                this.ticketInfo.taken = true
                            }else{
                                this.ticketInfo.taken = false
                            }
                        })
                    }
                    else{
                        this.ticketInfo.assigned = false
                        this.ticketInfo.assignedTo = 'This ticket is available to assign!'
                    }
                })

                const res = await axios({
                    method: 'get',
                    url: URL,
                    auth: {
                        username:API_KEY,
                        password:'X'
                    }
                });

                this.ticketInfo.data = res.data
                this.$emit('get-ticket-info',this.ticketInfo)

            }catch{err=>{
                console.log(err)
            }}
        },
    },
}
</script>